import React from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Briefcase, Users } from "lucide-react"
import { useAuth } from "@/contexts/AuthContext"

export function HeroSection() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const isHelper = user?.role === 'HELPER'

  return (
    <section className="relative overflow-hidden bg-[#fee39e]/30 py-12 md:py-20">
      {/* Background blobs */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-secondary/50 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          {/* Left: Text */}
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl leading-tight text-center">
              {t('home.hero.titlePrefix')}
              <span className="text-primary">{t('home.hero.titleHighlight')}</span>
            </h1>
            <p className="mt-5 text-base text-muted-foreground md:text-lg leading-relaxed text-center">
              {t('home.hero.description')}
            </p>

            {/* CTA */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              {!isHelper && (
                <Button asChild size="lg" className="group">
                  <RouterLink to="/candidates">
                    <Users className="mr-2 h-5 w-5" />
                    {t('home.hero.findHelpers')}
                  </RouterLink>
                </Button>
              )}
              <Button asChild size="lg" variant="outline" className="group">
                <RouterLink to="/job-postings">
                  <Briefcase className="mr-2 h-5 w-5" />
                  {t('home.hero.findJobs')}
                </RouterLink>
              </Button>
            </div>

            {/* Stats */}
            <div className="mt-10 grid grid-cols-3 gap-4">
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">{t('home.hero.stats.helpers.value')}</p>
                <p className="text-xs text-muted-foreground mt-1">{t('home.hero.stats.helpers.label')}</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">{t('home.hero.stats.matching.value')}</p>
                <p className="text-xs text-muted-foreground mt-1">{t('home.hero.stats.matching.label')}</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">{t('home.hero.stats.satisfaction.value')}</p>
                <p className="text-xs text-muted-foreground mt-1">{t('home.hero.stats.satisfaction.label')}</p>
              </div>
            </div>
          </div>

          {/* Right: Photo collage */}
          <div className="relative hidden md:grid grid-cols-2 gap-3 h-[420px]">
            <img
              src="/images/hero-1.jpg"
              alt="外傭照顧長者"
              className="w-full h-full object-cover rounded-2xl shadow-lg col-span-1 row-span-1"
            />
            <img
              src="/images/hero-2.jpg"
              alt="外傭照顧兒童"
              className="w-full h-full object-cover rounded-2xl shadow-lg col-span-1 row-span-1 mt-8"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
